import {Injectable} from '@angular/core';
import {ThemeCustomizationService} from 'app/core/services/theme-customization.service';


@Injectable({
    providedIn: 'root',
})
export class DefaultSavedReportService {
    get defaultSavedReport() {
        return this.themeCustom.themeBaseSettings.defaultSavedReport;
    }

    constructor (public themeCustom: ThemeCustomizationService) { }

    makeDefaultReport (reportId: string) {
        return this.themeCustom.setDashboardSettings({
            defaultSavedReport: reportId,
        });
    }
}
